import React, {Component} from 'react';
import {connect} from 'react-redux';

import './index.scss';

//components
import {XCloseIcon} from 'components/common/XCloseIcon/XCloseIcon';
import {getMediaPath, reactParserCommonOptions} from "../../../../app/functions";
import {
    CLOSE_TIME_NEWSLETTER_POPUP_ON_MOUNT_IN_MINUTES,
    LAST_NEWSLETTER_CLOSE_TIME,
    LAST_NEWSLETTER_REOPEN_DELAY_MINUTES,
} from "../../../../constants/common";
import PopupNewsletterForm from "../../../shared/popupNewslatterForm/popupNewsletterForm";
import ReactHtmlParser from "react-html-parser";


class NewsletterPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id,
            isShowCloseButton: false,
            formSubmitted: false
        }
        this.animateOut = this.animateOut.bind(this);
        this.animateIn = this.animateIn.bind(this);

        const closeDelaySeconds = this.props.newsletterPopup?.closeDelaySeconds ?? this.props.options?.closeDelaySeconds;
        if (closeDelaySeconds != null && !isNaN(Number(closeDelaySeconds))) {
            setTimeout(() => {
                this.setState({
                    isShowCloseButton: true
                })
            }, Number(closeDelaySeconds) * 1000)
        }
    }

    handleNewsletterClose() {
        this.animateOut()
        this.setCloseTime()
    }

    static getDerivedStateFromProps(props, state) {
        if (props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    componentDidMount() {
        this.animateIn();
        this.setCloseTimeDidMount();
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    setCloseTime() {
        localStorage.setItem(LAST_NEWSLETTER_CLOSE_TIME, Date.now().toString())
        localStorage.removeItem(LAST_NEWSLETTER_REOPEN_DELAY_MINUTES)
    }

    setCloseTimeDidMount() {
        localStorage.setItem(LAST_NEWSLETTER_CLOSE_TIME, Date.now().toString())
        localStorage.setItem(
            LAST_NEWSLETTER_REOPEN_DELAY_MINUTES,
            String(CLOSE_TIME_NEWSLETTER_POPUP_ON_MOUNT_IN_MINUTES)
        )
    }

    onClose() {
        this.setCloseTime()
    }

    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if (callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    onBackdropClick() {
        if (this.state.isShowCloseButton) {
            this.animateOut();
            this.onClose()
        }
    }

    onFormSubmit() {
        this.setState({formSubmitted: true})
        this.setCloseTime()
    }

    render() {
        const device = this.props.deviceState;
        const Text = this.props.text;
        const {mobileImage, desktopImage} = this.props.options;
        const newsletterPopup = this.props.newsletterPopup;
        const backgroundImage = device === 'mobile' ? 
            (newsletterPopup?.mobileImage || mobileImage) : 
            (newsletterPopup?.desktopImage || desktopImage)
        return (
            <div className={"backdrop " + this.state.animation_class} onClick={() => this.onBackdropClick()}>
                <div className={"popup_wrapper newsletter-popup " + this.state.animation_class}
                     onClick={(e) => e.stopPropagation()}>
                    <div className="popup_content">
                        <div className="top">
                            {this.state.isShowCloseButton && (
                                <button className="x_close_icon"
                                        onClick={() => this.handleNewsletterClose()}
                                        aria-label="סגור">
                                    <XCloseIcon
                                        className="x_close_icon_svg"
                                        color={newsletterPopup?.xColor} 
                                    />
                                </button>
                            )}
                            <img className="image" src={getMediaPath(backgroundImage)} alt=""/>
                        </div>
                        <div className="bottom">
                            {!this.state.formSubmitted ?(<>
                                <div
                                    className="title">{ReactHtmlParser(newsletterPopup.popupTitle || Text.web_newsletter_popup_title, reactParserCommonOptions())}</div>
                            </>): null}

                            <PopupNewsletterForm className="contact-popup-form"
                                                 submit_text={newsletterPopup?.submitText || Text.web_newsletter_popup_submit}
                                                 title=""
                                                 isFooter={false}
                                                 placeholder={newsletterPopup?.placeHolderText || Text.web_newsletter_popup_placeholder}
                                                 onSubmit={()=> this.onFormSubmit()}
                                                 isShow2Columns={true}
                                                 isShowFormTitle={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        options: store.config.Parameters.newsletter,
        newsletterPopup: store.config.newsletterPopup
    }
}

export default connect(mapStateToProps, null, null, {pure: false})(NewsletterPopup);
